import {
  updateEligibleTestLimit,
  isFullTestIdInTestList,
} from "./testTrackingHelpers";
import { ABTestLimit, DecodedTestInformation } from "./variationId";

export function updateStorageForExpiredTests(
  expiredTests: DecodedTestInformation[],
  isExclusive: boolean,
  currentLimit: number,
): number {
  let newTestLimit;
  if (!expiredTests.length) return currentLimit;
  if (isExclusive) {
    updateEligibleTestLimit(ABTestLimit);
    newTestLimit = ABTestLimit;
  } else {
    updateEligibleTestLimit(currentLimit + expiredTests.length);
    newTestLimit = currentLimit + expiredTests.length;
  }
  expiredTests.forEach((test) => {
    sessionStorage.removeItem(test.fullTestId);
  });
  return newTestLimit;
}

/**
 * Checks for any existing tests that are no longer active, aka are expired
 * Keeps track of number of expired tests and updates eligible test limit cookie
 * Should occur before trying to enroll user in any new tests to have the proper test limit
 */
export function getExpiredTestsFromCookie(
  testsCurrentlySavedInCookie: DecodedTestInformation[],
  allActiveFeatBitTestsInformation: DecodedTestInformation[],
) {
  // If the user was previously in an exclusive test, that should be the only test they had and now we reset their test limit to max
  const existingExclusiveTest = testsCurrentlySavedInCookie.find(
    (test) => test.exclusive,
  );

  // Must compare department Id + testId combination as fallthrough tests return the default value, which may not be the user's actual value
  const existingExclusiveFullTestId = existingExclusiveTest?.fullTestId;
  if (
    existingExclusiveFullTestId &&
    !isFullTestIdInTestList(
      allActiveFeatBitTestsInformation,
      existingExclusiveFullTestId,
    )
  ) {
    return { tests: [existingExclusiveTest], isExclusive: true };
  }

  // If no exclusive test expiring, check for any regular tests expiring
  const expiredTests = testsCurrentlySavedInCookie.filter((cookieTest) => {
    const existingFullTestId = cookieTest.fullTestId;
    return !isFullTestIdInTestList(
      allActiveFeatBitTestsInformation,
      existingFullTestId,
    );
  });
  return { tests: expiredTests, isExclusive: false };
}
